import { render, staticRenderFns } from "./JsonInput.vue?vue&type=template&id=1c016970&scoped=true"
import script from "./JsonInput.vue?vue&type=script&lang=ts"
export * from "./JsonInput.vue?vue&type=script&lang=ts"
import style0 from "./JsonInput.vue?vue&type=style&index=0&id=1c016970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c016970",
  null
  
)

export default component.exports